module.exports = __webpack_public_path__ + "static/yipinxiang-8c322195c97f2e72f667217b4edf784d.jpg";